import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToasterService } from '../../services/shared/toaster/toaster.service';
import { MatDialog } from '@angular/material';
import { WarningPopupComponent } from 'src/app/components/shared/warning-popup/warning-popup.component';
import { ConfigurationSettings } from 'src/app/models/configuration.settings';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  public userRoles: string[] = [];
  constructor(private toasterService: ToasterService, private router: Router, private dialogWarning: MatDialog, private configurationSettings: ConfigurationSettings) {

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      console.log(err);
      if (err.url && this.configurationSettings.hilUrl && err.url.toLowerCase().startsWith(this.configurationSettings.hilUrl.toLowerCase())) {
        return throwError(err);
      }
      if (err.status === 401) {    
        if (err.error && err.error == "Error: Invalid Access Token") {
          this.openWarning('expiredToken');
        }
        else
          this.router.navigate(['/error']);
      }
      if (err.error) {
        if (err.error.errors && err.error.errors.botId) {
          this.toasterService.error(err.error.errors.botId);
        }
        else if (err.error.value && typeof (err.error.value) == 'string' && err.error.value.startsWith("Error:")) {
          this.toasterService.error(err.error.value);
        }
        else if (typeof (err.error) == 'string' && err.error.startsWith("Error:")) {
          this.toasterService.error(err.error);
        }      
      const error = err.error.message || err.statusText;
      return throwError(error);
      }
    }))
  }
  openWarning(value: any) {
    let dialogRef = this.dialogWarning.open(WarningPopupComponent, {
      height: '35%',
      width: '35%',
      autoFocus: false,
      data: value
    });
    dialogRef.afterClosed().subscribe(result => {

    })
  }
}
